import React from 'react';

const HomeIcon = props => {
  const { className } = props;
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        stroke="#4a4a4a"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M.75 8.47L6.243 2.1a1 1 0 011.514 0L13.25 8.47"
      ></path>
      <path
        stroke="#4a4a4a"
        strokeLinejoin="round"
        d="M2.673 6.245l3.568-4.157a1 1 0 011.518 0l3.568 4.157.204 1.454a13.57 13.57 0 01-.027 3.947v0a1.357 1.357 0 01-1.34 1.15H3.836c-.67 0-1.24-.488-1.341-1.15v0A13.566 13.566 0 012.469 7.7l.204-1.454z"
      ></path>
      <path
        stroke="#4a4a4a"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M7 8.089c.921 0 1.668.746 1.668 1.667v3.04H5.332v-3.04c0-.92.747-1.667 1.668-1.667z"
      ></path>
    </svg>
  );
};

const NewInIcon = props => {
  const { className } = props;
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        stroke="#4a4a4a"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.98.803a.374.374 0 00-.383 0 .25.25 0 00-.057.326c.855 1.48 1.22 3.349.744 4.85-.308.97-1.56 1.026-2.078.149a5.292 5.292 0 01-.287-.56 3.73 3.73 0 00-1.918 3.357c.101 2.495 1.707 4.316 4.795 4.316s4.69-1.918 4.795-4.316C11.715 6.048 9.673 2.51 5.98.803z"
      ></path>
    </svg>
  );
};

const DogIcon = props => {
  const { className } = props;
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path
        stroke="#4a4a4a"
        strokeLinecap="round"
        d="M3.473 4.184s-1 3.1-1 5.5c0 3 2 3.5 4.5 3.5s4.5-.5 4.5-3.5c0-2.4-1-5.5-1-5.5"
      ></path>
      <path
        stroke="#4a4a4a"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.973 9.684l1 .5 1-.5"
      ></path>
      <path
        stroke="#4a4a4a"
        strokeLinecap="round"
        d="M8.723 6.184v.5M5.223 6.184v.5M2.579 8.184h-.503c-3-.5-1.03-4.807.397-6C3.595 1.245 5.68.816 7 .816c1.32 0 3.405.43 4.527 1.368 1.427 1.193 3.398 5.5.398 6h-.553"
      ></path>
    </svg>
  );
};

const CatIcon = props => {
  const { className } = props;
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      fill="none"
      viewBox="0 0 14 14"
    >
      <path stroke="#4a4a4a" strokeLinecap="round" strokeLinejoin="round" d="M6 8l1 .5L8 8"></path>
      <path stroke="#4a4a4a" strokeLinecap="round" d="M7 8.5v1.06"></path>
      <path
        stroke="#4a4a4a"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 10l.137.137a1 1 0 001.54-.152L7 9.5l.323.485a1 1 0 001.54.152L9 10"
      ></path>
      <path
        stroke="#4a4a4a"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5.5 3L3.753 1.003C3.145.308 2 .738 2 1.661V6L.5 7c0 3.722 2.336 6 6.5 6s6.5-2.278 6.5-6L12 6V1.661c0-.923-1.145-1.353-1.753-.658L8.5 3"
      ></path>
      <path
        stroke="#4a4a4a"
        strokeLinecap="round"
        d="M5 6v.5M9 6v.5M4.5 3.36c.333-.167 1-.5 2.5-.5s2.167.333 2.5.5"
      ></path>
    </svg>
  );
};

const BrandIcon = props => {
  const { className } = props;
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 511.993 511.993"
    >
      <g
        fill="none"
        stroke="#4a4a4a"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="15"
      >
        <circle cx="379.043" cy="119.215" r="22.002" data-original="#4a4a4a"></circle>
        <path
          d="M220.358 322.914l-28.603-63.793c-.519-1.239.724-2.484 1.963-1.967l63.635 28.765m-43.013 20.002l26.109-26.109m36.374-13.363l-46.77-46.77 77.41 14.168c1.433.261 1.646-.782.616-1.812l-45.717-44.841m76.011-27.767c12.529 12.529 15.489 29.397 4.65 40.622-3.608 3.736-13.063 13.263-13.063 13.263s-16.53-16.411-22.845-22.727c-5.187-5.187-22.719-22.653-22.719-22.653l12.879-12.879c12.1-12.099 28.569-8.155 41.098 4.374zM117.401 353.719c5.955 5.955 5.955 15.609 0 21.564a8164.205 8164.205 0 00-13.563 13.659l-10.83-10.83-10.782-10.782 13.611-13.611c5.955-5.955 15.61-5.955 21.564 0z"
          data-original="#4a4a4a"
        ></path>
        <path
          d="M145.017 372.919c6.966 6.966 6.966 18.26 0 25.225-3.455 3.455-15.932 16.044-15.932 16.044l-12.668-12.668-12.613-12.613 15.988-15.988c6.965-6.966 18.259-6.966 25.225 0zm14.697-34.089l42.048 2.68m-72.192-21.523l46.858 46.857m-9.346-60.014c6.726 6.726 6.281 18.075-.689 25.045-3.457 3.457-12.311 12.419-12.311 12.419s-8.897-8.786-12.287-12.176a9574.953 9574.953 0 00-12.209-12.147l12.452-12.452c6.969-6.969 18.318-7.414 25.044-.689z"
          data-original="#4a4a4a"
        ></path>
        <path
          d="M415.058 235.308l31.024-31.024a16.65 16.65 0 004.492-15.333L427.162 81.959a16.65 16.65 0 00-12.706-12.706L307.463 45.84a16.65 16.65 0 00-15.333 4.492L12.377 330.086c-6.502 6.502-6.502 17.045 0 23.547l12.613 12.613m24.387 24.387l93.405 93.405c6.502 6.502 17.045 6.502 23.547 0l224.006-224.003"
          data-original="#4a4a4a"
        ></path>
        <path
          d="M377.756 59.742a66.917 66.917 0 0112.384-17.044c26.16-26.16 68.573-26.16 94.733 0 26.16 26.16 26.16 68.573 0 94.733-26.16 26.16-68.573 26.16-94.733 0a67.011 67.011 0 01-11.469-15.306"
          data-original="#4a4a4a"
        ></path>
      </g>
    </svg>
  );
};

const SaleIcon = props => {
  const { className } = props;
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 512.003 512.003"
      style={{ fill: '#009345' }}
    >
      <path
        d="M477.958 262.633a15.004 15.004 0 010-13.263l19.096-39.065c10.632-21.751 2.208-47.676-19.178-59.023l-38.41-20.38a15.005 15.005 0 01-7.796-10.729l-7.512-42.829c-4.183-23.846-26.241-39.87-50.208-36.479l-43.053 6.09a15.004 15.004 0 01-12.613-4.099l-31.251-30.232c-17.401-16.834-44.661-16.835-62.061 0L193.72 42.859a15.01 15.01 0 01-12.613 4.099l-43.053-6.09c-23.975-3.393-46.025 12.633-50.208 36.479l-7.512 42.827a15.008 15.008 0 01-7.795 10.73l-38.41 20.38c-21.386 11.346-29.81 37.273-19.178 59.024l19.095 39.064a15.004 15.004 0 010 13.263L14.95 301.699c-10.632 21.751-2.208 47.676 19.178 59.023l38.41 20.38a15.005 15.005 0 017.796 10.729l7.512 42.829c3.808 21.708 22.422 36.932 43.815 36.93 2.107 0 4.245-.148 6.394-.452l43.053-6.09a15 15 0 0112.613 4.099l31.251 30.232c8.702 8.418 19.864 12.626 31.03 12.625 11.163-.001 22.332-4.209 31.03-12.625l31.252-30.232c3.372-3.261 7.968-4.751 12.613-4.099l43.053 6.09c23.978 3.392 46.025-12.633 50.208-36.479l7.513-42.827a15.008 15.008 0 017.795-10.73l38.41-20.38c21.386-11.346 29.81-37.273 19.178-59.024l-19.096-39.065zm-13.923 72.002l-38.41 20.38c-12.246 6.499-20.645 18.057-23.04 31.713l-7.512 42.828a15.038 15.038 0 01-16.987 12.342l-43.053-6.09c-13.73-1.945-27.316 2.474-37.281 12.113L266.5 478.152a15.04 15.04 0 01-20.997 0l-31.251-30.232c-8.422-8.147-19.432-12.562-30.926-12.562-2.106 0-4.229.148-6.355.449l-43.053 6.09a15.042 15.042 0 01-16.987-12.342l-7.513-42.829c-2.396-13.656-10.794-25.215-23.041-31.712l-38.41-20.38a15.037 15.037 0 01-6.489-19.969L60.574 275.6c6.088-12.456 6.088-26.742 0-39.198l-19.096-39.065a15.037 15.037 0 016.489-19.969l38.41-20.38c12.246-6.499 20.645-18.057 23.04-31.713l7.512-42.828a15.038 15.038 0 0116.987-12.342l43.053 6.09c13.725 1.943 27.316-2.474 37.281-12.113l31.252-30.232a15.04 15.04 0 0120.997 0l31.251 30.232c9.965 9.64 23.554 14.056 37.281 12.113l43.053-6.09a15.04 15.04 0 0116.987 12.342l7.512 42.829c2.396 13.656 10.794 25.215 23.041 31.712l38.41 20.38a15.037 15.037 0 016.489 19.969l-19.096 39.064c-6.088 12.455-6.088 26.743 0 39.198l19.096 39.064a15.039 15.039 0 01-6.488 19.972z"
        data-original="#4a4a4a"
      ></path>
      <path
        d="M363.886 148.116c-5.765-5.766-15.115-5.766-20.881 0l-194.889 194.89c-5.766 5.766-5.766 15.115 0 20.881a14.72 14.72 0 0010.44 4.325c3.778 0 7.558-1.441 10.44-4.325l194.889-194.889c5.768-5.767 5.768-15.115.001-20.882zm-166.945-25c-29.852 0-54.139 24.287-54.139 54.139s24.287 54.139 54.139 54.139 54.139-24.287 54.139-54.139-24.287-54.139-54.139-54.139zm0 78.747c-13.569 0-24.608-11.039-24.608-24.609 0-13.569 11.039-24.608 24.608-24.608s24.609 11.039 24.609 24.608c-.001 13.57-11.04 24.609-24.609 24.609zm118.12 78.747c-29.852 0-54.139 24.287-54.139 54.139s24.287 54.139 54.139 54.139c29.852 0 54.139-24.287 54.139-54.139s-24.287-54.139-54.139-54.139zm0 78.747c-13.569 0-24.609-11.039-24.609-24.608s11.039-24.608 24.609-24.608c13.569 0 24.608 11.039 24.608 24.608s-11.039 24.608-24.608 24.608z"
        data-original="#4a4a4a"
      ></path>
    </svg>
  );
};

const ServicesIcon = props => {
  const { className } = props;
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="-0.71 -0.71 20 20"
    >
      <g stroke="#4a4a4a" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.42}>
        <path d="M9.29 17.916a8.626 8.626 0 1 0 0-17.252 8.626 8.626 0 0 0 0 17.252Z" />
        <path d="M6.968 6.967a2.321 2.321 0 0 1 2.778-2.278 2.325 2.325 0 0 1 1.694 3.167 2.323 2.323 0 0 1-2.148 1.433v1.549M9.29 13.88a.332.332 0 1 1 0-.664M9.29 13.88a.332.332 0 1 0 0-.664" />
      </g>
    </svg>
  );
};

const ProjectPlanetIcon = props => {
  const { className } = props;
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      fill="none"
      viewBox="0 0 48 48"
    >
      <path
        stroke="#4a4a4a"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M5 24c1.628-3.531 5.242-9.749 8.687-13.701 1.249-1.432 3.377-1.432 4.626 0C21.758 14.25 25.373 20.469 27 24"
      ></path>
      <path
        stroke="#4a4a4a"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M19.053 11.178c2.029-2.777 4.188-5.398 6.26-7.354a3.16 3.16 0 014.373 0c.27.255.542.52.814.797M42 24c1.657 0 3.023 1.35 2.789 2.991C43.337 37.172 34.583 45 24 45 13.418 45 4.663 37.172 3.211 26.991 2.977 25.351 4.343 24 6 24h36z"
      ></path>
      <path
        stroke="#4a4a4a"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M15.523 24c.995 1.72 1.33 3.58.477 5.5-.871 1.96-2.502 2.687-4.148 3.42-1.775.792-3.568 1.591-4.443 3.955M24.428 24c-.148 4.884 3.092 5.743 5.88 6.483 1.661.44 3.161.838 3.692 2.017.39 1.172-.47 2.191-1.451 3.355-1.531 1.813-3.357 3.976-1.191 7.612M38.369 3.129c-2.052 2.239-4.381 6.56-5.369 8.9 0 0 .504.218 2.37.357-.998 1.87-1.862 3.772-2.37 5.097 0 0 1.091.517 6 .517s6-.517 6-.517c-.508-1.325-1.372-3.227-2.37-5.097 1.866-.139 2.37-.356 2.37-.356-.988-2.341-3.317-6.662-5.369-8.901a.85.85 0 00-1.262 0z"
      ></path>
      <path stroke="#4a4a4a" strokeLinecap="round" strokeWidth="3" d="M39 18v6"></path>
    </svg>
  );
};

export {
  HomeIcon,
  NewInIcon,
  DogIcon,
  CatIcon,
  BrandIcon,
  SaleIcon,
  ServicesIcon,
  ProjectPlanetIcon,
};
